import { render, staticRenderFns } from "./OpenAccess.vue?vue&type=template&id=0d4a196a&scoped=true&"
import script from "./OpenAccess.vue?vue&type=script&lang=js&"
export * from "./OpenAccess.vue?vue&type=script&lang=js&"
import style0 from "./OpenAccess.vue?vue&type=style&index=0&id=0d4a196a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4a196a",
  null
  
)

export default component.exports